<div class="grid cols-1fr-1fr-collapse gap-81px w-100">
  <div class="flex column no-wrap gap-27px w-100">
    <div>
      <div class="light-text">
        {{ 'revenue.pledge.edit.billing.revenue-item' | translate | titlecase }}
      </div>
      <div>
        <select
          class="form-control"
          [(ngModel)]="value.ItemNum"
          (change)="revenueItemChanged($event.target.value)"
          [disabled]="isLegacyArb"
        >
          <option value="0">{{ 'common.select' | translate | titlecase }}</option>
          <option *ngFor="let revenueItem of revenueItems" [value]="revenueItem.ItemNum">{{ revenueItem.ItemName }}</option>
        </select>
      </div>
    </div>
    <div class="flex row-collapse gap-27px no-wrap items-space-between-stretch">
      <div>
        <div class="light-text">{{ 'revenue.pledge.edit.billing.anchor-month' | translate | titlecase }}</div>
        <select class="form-control" [(ngModel)]="value.AnchorMonth" (change)="updateArbStart()" [disabled]="isLegacyArb">
          <option value="0">{{ 'common.select' | translate | titlecase }}</option>
          <option *ngFor="let month of months; let i = index" [value]="i + 1">{{ month }}</option>
        </select>
      </div>
      <div>
        <div class="light-text">{{ 'revenue.pledge.edit.billing.anchor-day' | translate | titlecase }}</div>
        <select class="form-control" [(ngModel)]="value.AnchorDay" (change)="updateArbStart()" [disabled]="isLegacyArb">
          <option value="0">{{ 'common.select' | translate | titlecase }}</option>
          <option *ngFor="let anchorDay of anchorDays" [value]="anchorDay">{{ anchorDay }}</option>
        </select>
      </div>
      <div>
        <div class="light-text">{{ 'revenue.pledge.edit.billing.starting-year' | translate | titlecase }}</div>
        <input class="form-control" type="text" [(ngModel)]="value.StartingYear" (change)="updateArbStart()" [disabled]="isLegacyArb" />
      </div>
    </div>
    <div>
      <div class="light-text">
        {{ 'revenue.pledge.edit.billing.billing-cycle' | translate | titlecase }}
      </div>
      <div>
        <select class="form-control" [(ngModel)]="value.BillingCycle" [disabled]="isLegacyArb" (change)="updateYearlyTotal()">
          <option value="0">{{ 'common.select' | translate | titlecase }}</option>
          <option *ngFor="let billingCycle of billingCycles" [value]="billingCycle.Name">{{ billingCycle.Name }}</option>
        </select>
      </div>
    </div>
    <div>
      <div class="light-text">
        {{ 'revenue.pledge.edit.billing.billing-expires' | translate | titlecase }}
      </div>
      <div>
        <div>
          <p-checkbox [binary]="true" [(ngModel)]="value.BillingExpires" [disabled]="isLegacyArb"></p-checkbox>
          <label class="ml-4">{{ 'revenue.pledge.edit.billing.billing-expires-long' | translate }}</label>
        </div>
        <wl-date-selector *ngIf="value.BillingExpires" appendTo="body" [(ngModel)]="value.BillingExpireDate"> </wl-date-selector>
      </div>
    </div>
    <div *ngIf="showAdditionalOptions">
      <div class="light-text">
        {{ 'revenue.pledge.edit.billing.additional-options' | translate | titlecase }}
      </div>
      <div class="flex row-collapse gap-27px no-wrap items-space-between-stretch">
        <div>
          <p-checkbox [binary]="true" [(ngModel)]="value.BillManually" [disabled]="isLegacyArb"></p-checkbox>
          <label>
            {{ 'revenue.pledge.edit.billing.bill-manually' | translate | titlecase }}
          </label>
        </div>
        <div>
          <p-checkbox [binary]="true" [(ngModel)]="value.InvoiceSeparately" [disabled]="isLegacyArb"></p-checkbox>
          <label>
            {{ 'revenue.pledge.edit.billing.invoice-separately' | translate | titlecase }}
          </label>
        </div>
        <div>
          <p-checkbox [binary]="true" [(ngModel)]="value.Inactive"></p-checkbox>
          <label>
            {{ 'revenue.pledge.edit.billing.inactive' | translate | titlecase }}
          </label>
        </div>
      </div>
    </div>
    <div *ngIf="showBillingNotes" class="w-100">
      <div class="light-text">{{ 'revenue.pledge.edit.billing.billing-notes' | translate | titlecase }}</div>
      <textarea [(ngModel)]="value.Notes" class="form-control" style="min-height: 72px"></textarea>
    </div>
    <div *ngIf="showOverrideDescription" class="w-100">
      <div class="light-text">{{ 'revenue.pledge.edit.billing.billing-descr' | translate | ucfirst }}</div>
      <textarea [(ngModel)]="value.Descr" class="form-control" style="min-height: 72px"></textarea>
    </div>
    <div *ngIf="showCommunicateWithProfile" class="w-100">
      <div class="light-text">{{ 'revenue.pledge.edit.billing.billing-contact' | translate | ucfirst }}</div>
      <p-select
        name="communicateWith"
        placeholder="{{ 'common.select' | translate | titlecase }}"
        optionValue="RelProfileID"
        optionLabel="ReportName"
        [options]="relatedProfiles"
        [(ngModel)]="value.CommunicateWithProfileID"
        [style]="{ width: '100%', height: '36px' }"
      ></p-select>
    </div>
    <div *ngIf="showAttention" class="w-100">
      <div class="light-text">{{ 'revenue.pledge.edit.billing.attention' | translate | ucfirst }}</div>
      <input type="text" [(ngModel)]="value.Attention" class="form-control" />
    </div>
    <div class="w-100">
      <div class="light-text">{{ 'revenue.pledge.edit.billing.sold-by' | translate | titlecase }}</div>
      <p-select
        name="soldBy"
        placeholder="{{ 'common.none' | translate | titlecase }}"
        optionValue="UserNum"
        optionLabel="UserName"
        [options]="allActiveUsers"
        [(ngModel)]="value.SoldBy"
        [style]="{ width: '100%', height: '36px' }"
        showClear
      ></p-select>
    </div>
  </div>
  <div class="w-100 mct-flex mct-col mct-gap-27">
    <div>
      <div class="light-text">
        {{ 'common.revenue.amount' | translate | titlecase }}
      </div>
      <div class="mct-flex mct-col mct-gap-27" *ngIf="itemHasArc">
        <div>
          <p-checkbox [binary]="true" [(ngModel)]="useArc" [disabled]="isLegacyArb"></p-checkbox>
          <label class="mb-0 ml-4">{{ 'revenue.pledge.edit.billing.pricing-calculation-long' | translate }}</label>
          <select
            class="form-control mt-4"
            [(ngModel)]="arcId"
            [disabled]="!useArc || isLegacyArb"
            (change)="arcChanged($event.target.value)"
          >
            <option value="0">{{ 'common.select' | translate | titlecase }}</option>
            <option value="0" *ngFor="let formula of arcFormulas" [value]="formula.ArcID" [hidden]="formula.ItemNum != value.ItemNum">
              {{ formula.Descr }}
            </option>
          </select>
        </div>
        <div class="f-wb mb-27 mct-flex mct-row mct-justify-center mct-items-center">- {{ 'common.or' | translate | uppercase }} -</div>
      </div>
      <div class="mct-grid mct-cols-1-1 mct-gap-27">
        <div class="w-100">
          <div class="light-text">{{ 'revenue.pledge.edit.billing.unit-price' | translate | titlecase }}</div>
          <div class="input-group">
            <span class="input-group-addon">$</span>
            <input
              type="number"
              class="form-control"
              [(ngModel)]="value.UnitPrice"
              [disabled]="useArc || isLegacyArb"
              mask="separator.2"
              thousandSeparator=","
              (change)="updateYearlyTotal()"
              step="0.01"
            />
          </div>
        </div>
        <div class="w-100">
          <div class="light-text">{{ 'common.revenue.quantity' | translate | titlecase }}</div>
          <input
            class="form-control"
            [(ngModel)]="value.Quantity"
            [disabled]="useArc || isLegacyArb"
            mask="0*"
            (change)="updateYearlyTotal()"
          />
        </div>
        <div class="w-100">
          <a class="mct-flex-1-1-0" *ngIf="!showBaseField" (click)="showBaseField = true">{{
            'revenue.pledge.edit.billing.add-a-base-price' | translate | ucfirst
          }}</a>
          <div class="mct-flex-1-1-0" [hidden]="!showBaseField">
            <div class="light-text">{{ 'revenue.pledge.edit.billing.base-price' | translate | titlecase }}</div>
            <div class="input-group">
              <span class="input-group-addon">$</span>
              <input
                type="number"
                class="form-control"
                [(ngModel)]="value.BasePrice"
                [disabled]="useArc || isLegacyArb"
                mask="separator.2"
                thousandSeparator=","
                name="basePrice"
                (change)="updateYearlyTotal()"
                step="0.01"
              />
            </div>
          </div>
        </div>
        <div class="w-100">
          <a class="mct-flex-1-1-0" *ngIf="!showFlatFeeField" (click)="showFlatFeeField = true">{{
            'revenue.pledge.edit.billing.add-a-flat-fee' | translate | ucfirst
          }}</a>
          <div class="mct-flex-1-1-0" [hidden]="!showFlatFeeField">
            <div class="light-text">{{ 'revenue.pledge.edit.billing.flat-fee' | translate | titlecase }}</div>
            <div class="input-group">
              <span class="input-group-addon">$</span>
              <input
                class="form-control"
                [(ngModel)]="value.FlatFee"
                [disabled]="useArc || isLegacyArb"
                mask="separator.2"
                thousandSeparator=","
                (change)="updateYearlyTotal()"
                step="0.01"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="mv-27 yearly-total">
      <div class="mct-flex mct-row mct-justify-center mct-items-center">
        {{ 'revenue.pledge.edit.billing.yearly-total' | translate | ucfirst }}: {{ value.YearlyAmount | currency }}
      </div>
    </div>
    <div *ngIf="showAllowARB" class="mv-27 mct-flex mct-row">
      <p-checkbox [binary]="true" [(ngModel)]="value.AllowPortalArbSubscription"></p-checkbox>
      <label class="ml-4 mb-0">{{ 'revenue.pledge.edit.billing.allow-portal-arb' | translate }}</label>
    </div>
    <div *ngIf="arbIsEnabled" class="w-100 mt-27">
      <div
        class="mct-flex mct-col"
        [title]="arbStartDate < today ? ('revenue.pledge.edit.billing.past-arb' | translate) : ''"
      >
        <div class="mct-flex mct-row" *ngIf="showSetAsARB">
          <p-checkbox [binary]="true" [(ngModel)]="arbSelected" [disabled]="arbStartDate < today || gatewayArbId || isCreatingArb"></p-checkbox>
          <label class="ml-4 mb-0">{{ 'revenue.pledge.edit.billing.set-as-arb' | translate }}</label>
        </div>
        <div [hidden]="!gatewayArbId" class="ml-27">
          <div class="light-text">
            {{ 'revenue.pledge.edit.billing.arb-subscription' | translate }}
          </div>
          <div>
            {{ gatewayArbId }}
          </div>
        </div>
      </div>
      <div [hidden]="!arbSelected || gatewayArbId">
        <div class="mv-27">
          <label class="light-text">{{ 'revenue.pledge.edit.billing.payment-type' | translate | titlecase }}</label>
          <select class="form-control" [(ngModel)]="selectedPaymentTypeId" (change)="selectedPaymentTypeChanged($event.target.value)">
            <option value="0">{{ 'common.select' | translate | titlecase }}</option>
            <option *ngFor="let type of paymentTypes" [value]="type.PaymentTypeId">{{ type.PaymentType }}</option>
          </select>
        </div>
        <wl-credit-card-input #creditCardInputComponent *ngIf="showCCPayment" [resolvedGateway]="resolvedGateway"></wl-credit-card-input>
        <wl-ach-input *ngIf="showACHPayment" [resolvedGateway]="resolvedGateway"
          (achInfoChanges)="updateACHInfo($event)"></wl-ach-input>
      </div>
    </div>
  </div>
</div>
